var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMountainsM = function SvgMountainsM(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 393 259"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Mountains-m_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m155.798 145.95-40.031-59.257L-39 222.173h1.52l89.919-71.437 14.864 14.343 21.56-15.937 15.823 18.564 24.515-18.564 33.956 15.718 25.356 37.33h3.786l-33.941-52.385 61.705-61.436 8.769 15.762 21.561-15.938 15.822 18.565 24.516-18.565 33.717 15.609 40.73 59.033 26.228 39.383h3.823l-25.303-40.338 65.428-63.402 8.213 14.76 21.561-15.937 15.822 18.564 24.517-18.564 33.762 15.629 95.82 116.542H636L487.171 34.35 367.356 158.013 276.274 26z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "Mountains-m_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h393v259H0z"
  })))));
};
export default SvgMountainsM;